import { default as finance } from './finance/services'

export default {
    ...finance
}